/**
 * PendantIcon — Reusable SVG illustration of a PalPendant device.
 *
 * Renders a simplified pendant (body, LCD screen, display lines, button) that
 * mirrors the styling of the PendantPreview component. Intended for empty
 * states, placeholders, and other decorative contexts.
 *
 * Props:
 *   width      — number or string (e.g. 100, "80px", "4rem"). Defaults to "100%".
 *   className  — optional extra class name applied to the <svg>.
 *   style      — optional inline style override.
 *   ...rest    — any other SVG attributes (e.g. aria-label).
 */
const PendantIcon = ({ width = '100%', className, style, ...rest }) => {
    return (
        <svg
            viewBox="0 0 100 110"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            className={className}
            style={style}
            aria-hidden={rest['aria-label'] ? undefined : true}
            {...rest}
        >
            {/* Pendant body */}
            <rect x="5" y="5" width="90" height="100" rx="14" ry="14" stroke="currentColor" strokeWidth="3" />
            {/* LCD screen */}
            <rect x="13" y="16" width="74" height="42" rx="6" ry="6" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="2" />
            {/* Header bar */}
            <line x1="17" y1="29" x2="83" y2="29" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.5" />
            <text x="18" y="27" fontSize="7" fill="currentColor" fillOpacity="0.5" fontFamily="monospace">11:35</text>
            <text x="65" y="27" fontSize="7" fill="currentColor" fillOpacity="0.5" fontFamily="monospace">99%</text>
            {/* Display lines */}
            <rect x="18" y="35" width="50" height="5" rx="2" fill="currentColor" fillOpacity="0.25" />
            <rect x="18" y="48" width="44" height="5" rx="2" fill="currentColor" fillOpacity="0.25" />
            {/* Button */}
            <circle cx="50" cy="82" r="14" stroke="currentColor" strokeWidth="2.5" />
        </svg>
    );
};

export default PendantIcon;
